// extracted by mini-css-extract-plugin
module.exports = {"got_btn":"APIRules_got_btn__3gO1C"};